export default __webpack_public_path__ + "static/media/M_Mapa.16c27f2b.svg";